



















import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import { ActionConstants } from '@/stores/enquiries/action-constants';
import { Enquiry } from '@/models/enquiry';
import { EnquiryHistory } from '@/models/enquiry-history';
import { EnquiryApi } from '@/api/enquiry-api';
import { EnquiryDocument } from '@/models/enquiry-document';
import { Forbidden } from '@/models/forbidden-error';
import enquiryDetails from '@/components/enquiry-details.vue';
import { NotFound } from '@/models/not-found-error';
import { EnquiryComment } from '@/models/enquiry-comment';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';

const enquiryApi = new EnquiryApi();
const userModule = namespace('user');

@Component({
    components: {
        enquiryDetails,
    },
})
export default class ViewEnquiry extends Vue {
    public isLoading: boolean = true;
    public enquiry: Enquiry | null = null;
    public documents: Array<EnquiryDocument> = new Array<EnquiryDocument>();
    public comments: Array<EnquiryComment> = new Array<EnquiryComment>();
    public history: Array<EnquiryHistory> = new Array<EnquiryHistory>();
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.load();
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.load();
    }
    public async load(): Promise<void> {
        try {
            const enquiry = await enquiryApi.fetchByIdAsync(this.$route.params.id);
            const history = await enquiryApi.fetchHistoryByIdAsync(this.$route.params.id);
            const documents = await enquiryApi.fetchDocumentsAsync(this.$route.params.id);
            const comments = await enquiryApi.fetchCommentsAsync(this.$route.params.id);
            this.enquiry = enquiry;
            this.documents = documents;
            this.comments = comments;
            this.history = history;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                this.$router.push({ name: 'not-found' });
            }
        }
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.load();
        this.isLoading = false;
    }
    public async handleDocumentUploaded(): Promise<void> {
        await this.load();
    }
    public async handleDocumentRemoved(index: number): Promise<void> {
        try {
            // NOTE(Dan): uiv has no typings yet.
            await (this as any).$confirm({ title: 'Confirm', content: 'This document will be permanantly deleted, are you sure?', size: 'md', okText: 'Delete', okType: 'danger' });

            const document = this.documents[index];

            await enquiryApi.deleteDocumentAsync(document.id, this.enquiry!.id!);

            await this.load();
        } catch (e) {
            // NOTE(Dan): Cancel button pressed, or the deletion failed.
        }
    }
    public async handleDocumentDownloaded(index: number): Promise<void> {
        try {
            const document = this.documents[index];

            await enquiryApi.downloadDocumentAsync(document.id, this.enquiry!.id!);
        } catch (e) {

        }
    }

    public async handleCommentAdded(commentValue: string | null): Promise<void> {
        try {
            if (commentValue != null) {
                const comment: EnquiryComment = {
                    value: commentValue,
                };
                await enquiryApi.createCommentAsync(this.enquiry!.id!, comment);
            }
        } catch (e) {
        }
        await this.load();
    }

    public async handleCommentRemoved(index: number): Promise<void> {
        try {
            // NOTE(Dan): uiv has no typings yet.
            await (this as any).$confirm({ title: 'Confirm', content: 'This document will be permanantly deleted, are you sure?', size: 'md', okText: 'Delete', okType: 'danger' });

            const comment = this.comments[index];

            await enquiryApi.deleteCommentAsync(comment!.id!, this.enquiry!.id!);

            await this.load();
        } catch (e) {
            // NOTE(Dan): Cancel button pressed, or the deletion failed.
        }
    }
}
